import styled from '@emotion/styled';
import { HeroImageComponent } from '@model/content';
import { BottomContainer } from '@components/common/hero/bottom/BottomContainer';
import { TitleContainer } from '@components/common/hero/title';
import { Image } from '@components/common/image';

const HeroImage: any = styled.div({
  width: '100vw',
  height: '50vh',
  position: 'relative'
});

const StyledImage = styled(Image)({
  objectFit: 'cover'
});

export const HeroContainer = ({ images, destination, title }: HeroImageComponent) => {
  if (!images || !Array.isArray(images)) {
    return null;
  }
  return (
    <HeroImage>
      <StyledImage src={images[0]} alt={''} fill sizes={'100vw'} quality={80} priority />
      <BottomContainer destination={destination} />
      {title && <TitleContainer title={title} />}
    </HeroImage>
  );
};
